import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import SurveyPendampingan from 'app/KinerjaPenilikPegawaiPage/pages/Pelaksanaan/PraktikKinerja/SurveyPendampingan/SurveyPendampingan'
import { PageGuardKSPNF } from 'app/KinerjaKepalaSKBPage/components/PageGuardKSPNF'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (_: NextPageContext, toggle: TToggleKeyValuePair) => {
    const isEnabled = toggle['kinerja-spnf-enabled'] || false

    if (!isEnabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const SurveyPendampinganPage = () => (
  <PageGuardKSPNF>
    <SurveyPendampingan />
  </PageGuardKSPNF>
)

SurveyPendampinganPage.Layout = KinerjaLayout

SurveyPendampinganPage.layoutOpts = {
  hasHeader: true,
  centered: true,
}

export default SurveyPendampinganPage
